import styled from 'styled-components';
import { ChevronDownIc } from '@dsch/dd-icons';

interface IChevron {
  $isMenuOpen: boolean;
  $isDisabled: boolean;
}

export const List = styled.ul`
  flex: 1 1 auto;
  padding: ${({ theme }) => theme.spacing.M16};
  margin-top: ${({ theme }) => theme.spacing.S8};
  margin-bottom: ${({ theme }) => theme.spacing.S8};
`;

export const ListWrapper = styled(List)`
  background: ${({ theme }) => theme.colors.OFFWHITE};
  margin-top: ${({ theme }) => theme.spacing.M16};
  padding: ${({ theme }) => theme.spacing.S8}
    ${({ theme }) => theme.spacing.M16};
`;

export const ListItemOpen = styled.span<{ isOpen: boolean }>`
  color: ${({ theme, isOpen }) =>
    isOpen ? theme.colors.GREEN : theme.colors.RED_DARK};
`;

export const ListItemOpenHours = styled.span<{ isOpen: boolean }>`
  color: ${({ theme, isOpen }) =>
    isOpen ? theme.colors.GREEN : theme.colors.GREY_DARKER};
`;

export const ListItemTitle = styled.span<{ isBold: boolean }>`
  color: ${({ theme }) => theme.colors.GREY_DARKER};
  font-weight: ${({ theme, isBold }) =>
    isBold ? theme.fontWeight.bold : theme.fontWeight.regular};
`;

export const ListItem = styled.li<{ isOpen: boolean }>`
  ${({ theme }) => theme.fontSize.M14};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  word-break: break-word;
  display: flex;
  justify-content: space-between;
  .day {
    color: ${({ theme, isOpen }) =>
      isOpen ? theme.colors.GREEN : theme.colors.GREY_DARK};
  }
  .hours {
    color: ${({ theme, isOpen }) =>
      isOpen ? theme.colors.GREEN : theme.colors.GREY_DARKER};
  }
`;

export const DealerContactStatus = styled.div`
  display: flex;
  ${({ theme }) => theme.fontSize.M14};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  word-break: break-word;
  justify-content: space-between;
  cursor: pointer;
`;

export const HoursWrapper = styled.div`
  padding-bottom: ${({ theme }) => theme.spacing.S8};
`;

export const DealerChevron = styled(ChevronDownIc)<IChevron>`
  margin-left: ${({ theme }) => theme.spacing.S4};
  color: ${({ theme }) => theme.colors.GREY_DARKER};
  transform: rotate(${({ $isMenuOpen }) => ($isMenuOpen ? '180deg' : '0')});
`;
